
import MagnifyingGlassIcon from "../../assets/icon/magnifyingGlassIcon";
import { InputProps } from "./input.props";
import { Input } from "./input.styled";

const AGInput: React.FC<InputProps> = ({ maxLength, value, max, min, placeholder, type, accept, ref, icon, onClick, showIcon = false,currency, ...props }) => {
    return (

        !showIcon ? <Input ref={ref ? ref : undefined} accept={accept} type={type} placeholder={placeholder} value={value} maxLength={maxLength} max={max} min={min} {...props} />
            : <div className="relative">
                <Input ref={ref ? ref : undefined} accept={accept} type={type} placeholder={placeholder} value={value} maxLength={maxLength} max={max} min={min} {...props} className="!pr-[30px]" />
                <button type="button" onClick={onClick} className="absolute top-[10px] right-[8px]">
                    <MagnifyingGlassIcon width={20} height={20} color="#0871a1" />
                </button>
            </div>
    );
};

export default AGInput;



